import { DoctorOptions } from "pages/Electrocardiography/tabs/DetailDiagnose/PatientInfo/config";
import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COLOR, AUTO_COMPLETE, COMBO_BOX } = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã mẫu",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên mẫu điện tim",
    name: "tenMauDienTim",
    rules: [{ required: true, message: "Chưa nhập tên mẫu điện tim" }],
  },
  {
    type: COMBO_BOX,
    label: "Tên người đọc kết quả",
    name: "tenNguoiDocKQ",
    rules: [{ required: true, message: "Chưa nhập tên người đọc kết quả" }],
    options: DoctorOptions,
  },
  {
    type: SELECT,
    label: "Trạng thái",
    name: "trangThai",
    options: [
      { value: true, label: "Đang sử dụng" },
      { value: false, label: "Không sử dụng" },
    ],
    rules: [{ required: true, message: "Chưa chọn trạng thái" }],
  },
];
export { dataFields };
